<template>
  <div class="not-found">
    <p>404</p>
    <v-btn color="primary" text to="/">{{ $t('notFound.back') }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="less" scoped>
.not-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  font-size: 10em;
}
</style>
